webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Game',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js PWA',
      boardRows: ['top', 'mid', 'bot'],
      startsGame: 'x',
      turn: 'x',
      state: [['', '', ''], ['', '', ''], ['', '', '']],
      gameEnd: false,
      results: 'game is in progress'
    };
  },

  methods: {
    placePiece: function placePiece(event) {
      // Set clicked Square
      if (!this.gameEnd) {
        var square = event.target;

        if (!square.children.length) {
          // TODO: couple the state and view of these squares

          // visually Add 'x' or 'o' to square clicked
          square.appendChild(document.createElement('div'));
          square.children[0].classList.add(this.turn);

          // Set internal state of clicked square to 'x' or 'o'
          var coords = square.id.split(',');
          this.state[coords[0]][coords[1]] = this.turn;

          this.checkWinner();

          this.turn = this.turn === 'x' ? 'o' : 'x';
        }
      }
    },
    checkWinner: function checkWinner() {
      // Checks row, column, and diagonal winners
      // TODO: I bet this could be done better with just a flat array
      // using i/3 and i%3 for the positions
      // checking for cats game is ez just looking for ''
      var row = [];
      for (var i = 0; i < 3; i++) {
        row = this.state[i];
        if (row[0] === row[1] && row[0] === row[2] && row[0] === this.turn) {
          this.handleWinner();
          return;
        }
      }

      var col = this.state;
      for (var _i = 0; _i < 3; _i++) {
        if (col[0][_i] === col[1][_i] && col[0][_i] === col[2][_i] && col[0][_i] === this.turn) {
          this.handleWinner();
          return;
        }
      }
      var diag = this.state;
      if (diag[0][0] === diag[1][1] && diag[0][0] === diag[2][2] && diag[0][0] === this.turn) {
        this.handleWinner();
        return;
      }

      if (diag[0][2] === diag[1][1] && diag[0][2] === diag[2][0] && diag[0][2] === this.turn) {
        this.handleWinner();
        return;
      }
      for (var _i2 = 0; _i2 < 3; _i2++) {
        for (var j = 0; j < 3; j++) {
          if (this.state[_i2][j] === '') {
            return;
          }
        }
      }
      this.handleTie();
    },
    handleWinner: function handleWinner() {
      this.results = this.turn + ' is the winner';
      this.gameEnd = true;
    },
    handleTie: function handleTie() {
      this.results = 'It\'s a cats game!';
      this.gameEnd = true;
    },
    resetGame: function resetGame() {
      console.log('reset button pushed');
      this.startsGame === 'o' ? this.startsGame = this.turn = 'x' : this.startsGame = this.turn = 'o';
      this.state = [['', '', ''], ['', '', ''], ['', '', '']];
      this.gameEnd = false;

      // Pick up the pieces
      var piece = document.querySelector('.x, .o');
      while (piece) {
        piece.remove();
        piece = document.querySelector('.x, .o');
      }
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(13);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d60177a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(12);
function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d60177a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('span',[_vm._v("Tic - Zac - Toe")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_game__ = __webpack_require__(15);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Game',
    component: __WEBPACK_IMPORTED_MODULE_2__components_game__["a" /* default */]
  }]
}));

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_game_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98cbbe90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_game_vue__ = __webpack_require__(17);
function injectStyle (ssrContext) {
  __webpack_require__(16)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_game_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98cbbe90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_game_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{ noClicky: _vm.gameEnd },attrs:{"id":"board"}},_vm._l((_vm.boardRows),function(row,index){return _c('div',{attrs:{"id":_vm.boardRows[index]}},[_c('div',{staticClass:"square",attrs:{"id":index+',0'},on:{"click":_vm.placePiece}}),_vm._v(" "),_c('div',{staticClass:"square",attrs:{"id":index+',1'},on:{"click":_vm.placePiece}}),_vm._v(" "),_c('div',{staticClass:"square",attrs:{"id":index+',2'},on:{"click":_vm.placePiece}})])})),_vm._v(" "),(_vm.gameEnd)?_c('div',{attrs:{"id":"results"}},[_c('p',[_vm._v("\n      "+_vm._s(this.results)+"\n    ")]),_vm._v(" "),_c('button',{on:{"click":_vm.resetGame}},[_vm._v("New Game")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.e60440f8b47d61360d88.js